import common from './common.json';
import survey from './survey.json';

export const ru = {
  common,
  survey,
};
